import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../assets/css/add-new-question.css";
import { QUESTION } from "../services/Questions";
import { Redirect } from 'react-router';
import Loader from './Loader';
import Header from "./Header";
import Menu from "./Menu";
import { CONFIG, URLS ,encryptPHI,decryptPHI, getLoggedInData} from "../helpers/Common";

class PatientResponse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      patient_additional_info: "",
      prevStep: 5,
      profileData: new Array(),
      redirect: false,
      isLoading : false,
      surgeon_id:'',
      clinic_id:'',
      patientData: '',
      allComplains: '',
      oldData: '',
      isEmail: false
    };
    this.handleAction = this.handleAction.bind(this);
    this.setAddionalInfo = this.setAddionalInfo.bind(this);
    this.handlePrevAction           = this.handlePrevAction.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
  }

  
  componentWillMount() {

    let userData = getLoggedInData();

    this.setState({
        surgeon_id: userData.user_id,
        clinic_id: userData.clinic_id,
    })

    this.setState({
      profileData: this.props.getProfileData
    });
    
  }

  handleCheckboxChange = event =>{

    // console.log(event.target.checked);
    this.setState({ isEmail: event.target.checked });
  }

  handlePrevAction = (e)=>{
    this.props.setSelectedComplains(this.props.getComplainData.complain_types);
    this.props.setIsModify(true);
    this.props.handleNextPrevSteps(5);
  }

  handleAction = e => {
    this.setState({
      isLoading:true
    })
    
    let profileData = this.state.profileData;
    profileData.patient_additional_info = this.state.patient_additional_info;

    var encryptedprofileData = encryptPHI(CONFIG.ENCRYPTION_KEY,JSON.stringify(profileData));

    localStorage.setItem('patientProfile', encryptedprofileData); 
   
    
    var decryptedData = decryptPHI(CONFIG.ENCRYPTION_KEY,localStorage.getItem("data"));
    let data = JSON.parse(decryptedData);
    
    var encryptedData = encryptPHI(CONFIG.ENCRYPTION_KEY,JSON.stringify(data));

    localStorage.setItem("oldData",encryptedData);
    
    let complainData = this.props.getComplainData.complainTypeDetails;
    let saveData = new Array();
    let complainLocationData = this.props.getComplainLocationData;
    saveData = {
      title: profileData.title,
      first_name: profileData.first_name,
      last_name: profileData.last_name,
      email: profileData.email,
      phone: profileData.phone,
      gender: profileData.gender,
      narrative_summary: profileData.narrative_summary,
      surgeon_id: this.props.surgeon_id,
      dob: profileData.dob,
      patient_additional_info: this.state.patient_additional_info,
      answers:data
    };
    //console.log(saveData)
   
    var encryptedData = encryptPHI(CONFIG.ENCRYPTION_KEY,JSON.stringify(saveData));
    var encryptedComplainsData = encryptPHI(CONFIG.ENCRYPTION_KEY,JSON.stringify(this.props.getAllComplains));

    localStorage.setItem("data",encryptedData);
    localStorage.setItem("allComplains",encryptedComplainsData);

    var  patientData         = decryptPHI(CONFIG.ENCRYPTION_KEY,localStorage.getItem("data"));
    var  allComplains        = decryptPHI(CONFIG.ENCRYPTION_KEY,localStorage.getItem("allComplains"));
    var  oldData             = decryptPHI(CONFIG.ENCRYPTION_KEY,localStorage.getItem("oldData"));
    var  newData             = localStorage.getItem("newData");
    this.setState({
              patientData:JSON.parse(patientData),
              allComplains: JSON.parse(allComplains),
              oldData:JSON.parse(oldData)
          })
          // console.log('decryptedData ',patientData)
          // console.log('allComplains ',allComplains)
          // console.log('oldData ',oldData)
          // console.log('newData ',newData)

    setTimeout(()=>{
      this.savePatientNarratives(this.state.isEmail)
  
          },2000);
  };

  savePatientNarratives = (isExport)=>
    {

        let data = this.state.patientData;
        let title = encryptPHI(CONFIG.ENCRYPTION_KEY,data.title);
        let first_name = encryptPHI(CONFIG.ENCRYPTION_KEY,data.first_name);
        let last_name = encryptPHI(CONFIG.ENCRYPTION_KEY,data.last_name);
        let email = encryptPHI(CONFIG.ENCRYPTION_KEY,data.email);
        let phone = encryptPHI(CONFIG.ENCRYPTION_KEY,data.phone);
        let gender = encryptPHI(CONFIG.ENCRYPTION_KEY,data.gender);
        let narrative_summary = encryptPHI(CONFIG.ENCRYPTION_KEY,data.narrative_summary);
        let dob = encryptPHI(CONFIG.ENCRYPTION_KEY,data.dob);
        let patient_additional_info = '';
        if(data.patient_additional_info){
           patient_additional_info = encryptPHI(CONFIG.ENCRYPTION_KEY,data.patient_additional_info);

        } 
        //let allComplains = encryptPHI(CONFIG.ENCRYPTION_KEY,this.state.allComplains);
        let allComplains = this.state.allComplains;
        for (let index = 0; index < allComplains.length; index++) {
            
            allComplains[index].profileSummary    = encryptPHI(CONFIG.ENCRYPTION_KEY,allComplains[index].profileSummary);
            allComplains[index].narrativeSummary  = encryptPHI(CONFIG.ENCRYPTION_KEY,allComplains[index].narrativeSummary);
            allComplains[index].myNarrativeData   = encryptPHI(CONFIG.ENCRYPTION_KEY,allComplains[index].myNarrativeData);

        }
       // allComplains[0].profileSummary = encryptPHI(CONFIG.ENCRYPTION_KEY,allComplains[0].profileSummary);

        data.title          = title;
        data.first_name     = first_name;
        data.last_name      = last_name;
        data.email          = email;
        data.phone          = phone;
        data.gender         = gender;
        data.narrative_summary  = narrative_summary;
        data.dob                = dob; 
        data.patient_additional_info = patient_additional_info;
       
        data.isExport       = isExport;
        data.surgeon_id     =this.state.surgeon_id;
        data.clinic_id      =this.state.clinic_id;
        data.allComplains   =this.state.allComplains;
        data.newData = localStorage.getItem("newData");
        data.data=this.state.oldData; 
        
        QUESTION.savePatientNarratives(data).then(res => {
            if(res.data.header.error==0)
            {
                localStorage.removeItem('data');
                localStorage.removeItem('patientProfile');
                // this.setState({redirect: true});
                this.setState({
                  redirect:true,
                  isLoading:false
                })
            }
            else
            {
                alert('something went wrong! please submit complain again');
                // this.setState({redirect: true});
            }
            
        }).catch(err => {
            alert("There was an error! please submit complain again ");
            // this.setState({redirect: true});
        });
       
    }

  setAddionalInfo = e => {
    this.setState({
      patient_additional_info: e.target.value
    });
  };

  
  render() {
    if (this.state.redirect) {
      return <Redirect push to="/thankyou" />;
    }
    return (
      <React.Fragment>
        <Header
          title="Patient Narrative Response"
          titleImage="ic-medical-result.png"
        />
        <Menu />
        <section className="sec--question add-new-question">
          <form>
            <div className="question-form">
              <div className="container">
                <div className="row">
                  <div className="col-md-1 col-sm-1" />
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="form-group">
                      <label htmlFor="txt">Add any information that you might want to share</label>
                      <textarea
                        id="txt"
                        className="form-control"
                        onChange={this.setAddionalInfo}
                        disabled={ this.state.isLoading }
                      />
                      <label>
                      <input type="checkbox"
                        value="emailChecked"
                        checked={this.state.isEmail}
                        onChange={this.handleCheckboxChange}
                      />
                      &nbsp; Do you want to get a copy of this assessment emailed to you?
                      </label>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
        <div className="sec-btn patient--btn">

          <Link to="#" className="btn-img" onClick={this.handlePrevAction}>
            <img src={require("../assets/img/icons/ic-prev.png")} alt="" />
          </Link>

          {/*<Link to="#" className="btn-img" onClick={this.handleAction}>*/}
          {/*  <img*/}
          {/*    src={require("../assets/img/icons/ic-incomplete-native.png")}*/}
          {/*    alt=""*/}
          {/*  />*/}
          {/*  <span>Skip</span>*/}
          {/*</Link>*/}
          {
              this.state.isLoading!=0 &&
              <Loader/>
          }
          <Link to="#" className={this.state.isLoading !=0 ? 'btn-img btn-disable' : 'btn-img'} onClick={(this.state.isLoading !=0) ? e => e.preventDefault() : this.handleAction} >
            
            <img
              src={require("../assets/img/icons/ic-complete-native.png")}
              alt=""
            />
            <span>Save</span>
          </Link>
        </div>
      </React.Fragment>
    );
  }
}

export default PatientResponse;
